import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'page-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss']
})
export class AvatarComponent implements OnInit {

  @Input() public gender: any = 'Female';
  @Input() public avatar: any = '';

  constructor(
    private readonly router: Router
  ) {



   }

  ngOnInit() {
    if (this.avatar == undefined) {
      this.avatar = '';
    }
  }

  getIcon(gender: string) {
    if (gender == 'Male') {
      return 'face_6';
    } 
    return 'face_4'    
  }

}
